export * from './lib/resize-observer.module';
export * from './lib/services/resize-observer.service';
